import Image from 'next/image';
import Link from 'next/link';
import { IOfferItem } from '@/interfaces/homepage';
import { ReactNode } from 'react';

const Wrapper = ({ redirectUrl, children }: { redirectUrl?: string; children: ReactNode }) => {
  if (redirectUrl) return <Link href={redirectUrl}>{children}</Link>;
  else return <>{children}</>;
};

export function OfferCard({ offer }: Readonly<{ offer: IOfferItem }>) {
  return (
    <div className="h-full border border-gray-300 pb-3">
      <Wrapper redirectUrl={offer?.RedirectURL}>
        <div className="relative aspect-[3/2] overflow-hidden border-b border-gray-300 bg-slate-100 md:aspect-[4/3]">
          <Image
            src={offer.ImageURL || '/images/product_default_img.png'}
            alt={offer.Title || 'default image'}
            fill
            quality={100}
            priority
            className="object-cover"
          />
        </div>
      </Wrapper>

      <div className="flex flex-1 flex-col items-center gap-1 pt-4">
        <span className="text-lg font-semibold leading-6 text-gray-600">{offer.Title}</span>

        {offer?.Description && (
          <a
            href={offer.Description}
            target="_blank"
            rel="noopener noreferrer"
            className="text-lg font-semibold text-gray-600 underline hover:text-black"
          >
            Terms
          </a>
        )}
      </div>
    </div>
  );
}
